/**
 * 渠道追踪工具
 * 用于保存和读取渠道邀请方信息，支持7天有效期
 */

const CHANNEL_KEY = 'channel_referrer';
const CHANNEL_EXPIRE_DAYS = 7;

/**
 * 保存渠道信息到 localStorage，带过期时间
 * @param {string} channelId - 渠道ID
 */
export function saveChannelReferrer(channelId) {
  if (!channelId) return;

  const expireTime = Date.now() + CHANNEL_EXPIRE_DAYS * 24 * 60 * 60 * 1000; // 2天后过期
  const channelData = {
    channelId: channelId,
    expireTime: expireTime,
    createTime: Date.now(),
  };

  try {
    window.localStorage.setItem(CHANNEL_KEY, JSON.stringify(channelData));
    // eslint-disable-next-line no-console
    console.log('渠道信息已保存:', channelId);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('保存渠道信息失败:', error);
  }
}

/**
 * 获取渠道信息，如果过期则返回 null
 * @returns {string|null} - 渠道ID 或 null
 */
export function getChannelReferrer() {
  try {
    const channelDataStr = window.localStorage.getItem(CHANNEL_KEY);
    if (!channelDataStr) return null;

    const channelData = JSON.parse(channelDataStr);
    
    // 检查是否过期
    if (Date.now() > channelData.expireTime) {
      // 已过期，清除数据
      clearChannelReferrer();
      return null;
    }

    return channelData.channelId;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('读取渠道信息失败:', error);
    return null;
  }
}

/**
 * 清除渠道信息
 */
export function clearChannelReferrer() {
  try {
    window.localStorage.removeItem(CHANNEL_KEY);
    // eslint-disable-next-line no-console
    console.log('渠道信息已清除');
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('清除渠道信息失败:', error);
  }
}

/**
 * 获取渠道信息的详细数据（包含过期时间等）
 * @returns {object|null} - 渠道数据对象或 null
 */
export function getChannelReferrerDetail() {
  try {
    const channelDataStr = window.localStorage.getItem(CHANNEL_KEY);
    if (!channelDataStr) return null;

    const channelData = JSON.parse(channelDataStr);
    
    // 检查是否过期
    if (Date.now() > channelData.expireTime) {
      clearChannelReferrer();
      return null;
    }

    return channelData;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('读取渠道详细信息失败:', error);
    return null;
  }
}

/**
 * 检查并上报渠道信息
 * 这个函数应该在用户登录成功后调用
 * @param {Function} reportApi - 上报 API 函数
 * @returns {Promise} - 上报结果的 Promise
 */
export function checkAndReportChannel(reportApi) {
  const channelId = getChannelReferrer();
  if (!channelId) {
    return Promise.resolve(null);
  }

  // eslint-disable-next-line no-console
  console.log('准备上报渠道信息:', channelId);

  return reportApi(channelId)
    .then(() => {
      // eslint-disable-next-line no-console
      console.log('渠道信息上报成功:', channelId);
      // 上报成功后清除缓存
      clearChannelReferrer();
      return channelId;
    })
    .catch(err => {
      // eslint-disable-next-line no-console
      console.error('渠道信息上报失败:', err);
      // 上报失败不影响正常流程，保留缓存待下次重试
      throw err;
    });
}
